<template>
    <el-dialog
    :title="boxShow.flag == 1?'编辑文章':'新增文章'"
    :visible.sync="boxShow.isShow"
    :before-close="handleClose"
    width="100%"
    :fullscreen="true"
    center>
    <el-form ref="form" :rules="rules" :model="form" class="form-inline" label-width="80px">
        <el-row>
           <el-col :span="8">
                <el-form-item label="主标题:" label-width="110px" prop="mainTitle">
                    <el-input v-model="form.mainTitle" placeholder="请输入文章主标题"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="副标题:" label-width="110px" prop="subTitle">
                    <el-input v-model="form.subTitle" placeholder="请输入文章副标题"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="文章简介:" label-width="110px" prop="introduction">
                    <el-input v-model="form.introduction" placeholder="请输入文章简介"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="8">
                <el-form-item label="封面图片:" label-width="110px" prop="coverimg">
                    <el-input type="file" v-model="form.coverImg" value="123456" @change="handleFileChange"></el-input>
                </el-form-item>
                <el-form-item label-width="110px">
                    <img class="coverImg" :src=this.src alt="">
                </el-form-item>
                
            </el-col>
            <el-col :span="8">
                <el-form-item label="类型:" label-width="110px" prop="type">
                    <el-select v-model="form.type"  placeholder="请选择文章类型">
                        <el-option label="新闻动态" value="1"></el-option>
                        <el-option label="企业资质" value="2"></el-option>
                        <el-option label="荣誉证书" value="3"></el-option>
                        <el-option label="新闻播报" value="4"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="发布日期:" label-width="110px" prop="publicationDate">
                    <el-date-picker
                    v-model="form.publicationDate"
                    value-format="yyyy-MM-dd hh:mm:ss"
                    format="yyyy-MM-dd hh:mm:ss"
                    type="date"
                    placeholder="选择发布日期">
                    </el-date-picker>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <div v-if="boxShow.isShow" style="border: 1px solid #ccc;">
                    <div class="image-size-toolbar" v-show="selectedImageIndex !== null && selectedImageIndex !== undefined">
          <span style="margin-right: 10px;">图片宽度：</span>
          <el-button size="small" @click="setImageWidth('30%')">30%</el-button>
          <el-button size="small" @click="setImageWidth('40%')">40%</el-button>
          <el-button size="small" @click="setImageWidth('50%')">50%</el-button>
          <el-button size="small" @click="setImageWidth('60%')">60%</el-button>
          <el-button size="small" @click="setImageWidth('70%')">70%</el-button>
          <el-button size="small" @click="setImageWidth('80%')">80%</el-button>
          <el-button size="small" @click="setImageWidth('90%')">90%</el-button>
          <el-button size="small" @click="setImageWidth('100%')">100%</el-button>
        </div>
                    <Toolbar
                        style="border-bottom: 1px solid #ccc"
                        :editor="editor"
                        :defaultConfig="toolbarConfig"
                        :mode="mode"
                    />
                    <Editor
                        style="height:55vh; overflow-y: hidden;"
                        v-model="html"
                        :defaultConfig="editorConfig"
                        :mode="mode"
                        @onChange="onChange"
                        @onCreated="onCreated"
                    />
                </div>
            </el-col>
        </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submit(form)">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import Vue from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { mapState,mapActions} from 'vuex'
import axios from "@/utils/http"  //获取封装的axios
import { Message, Upload } from "element-ui"; //调用element-ui 的message功能


// import { useStore } from 'vuex'
// const store = useStore()
export default {
    components:{ Editor,Toolbar,content:{
      type:String,
      default:"",
    } },
    props:['boxShow','formInline'],
    computed:{
        ...mapState('article',['projectDropList','teamList','cardList'])
    },
    data(){
        return{
            form:{
                id: null,
                mainTitle:null,
                subTitle:null,
                introduction:null,
                coverImg:null,
                type:null,
                publicationDate:null,
                content:null,
            },
            selectedFile:{
                multipartFile:null,
                prefix:null,
            },
            rules:{
                mainTitle:[
                    {required:true,message:'设备分类名称不能为空',trigger:'blur'},
                ],
            },
            src:null,
            // 富文本框输入
            editor:null,
            html:'',
            toolbarConfig:{ },
            editorConfig:{ 
                hoverbarKeys: {
                    image: {
            // 保留编辑和查看链接功能 删除功能
            menuKeys: ['editImage', 'viewImageLink','deleteImage']
        }
                },
                placeholder:'请输入内容...',
                MENU_CONF:{
                // 配置上传图片
                uploadImage:{
                    customUpload:this.update
                    // 后端上传地址 必填
                    // server:"https://192.168.1.97:8088/api/upload/img",
                    // fieldName:"file",
                    // meta:{},
                    // // 请求头
                    // headers:{'Authorization':`Bearer ${localStorage.getItem("token")}`},
                    // timeout:5 * 100, //5s超过时间
                    // // 选择文件时的类型限制,默认为['image/*']如不想限制，则设置为[]
                    // allowedFileType:["image/*"],
                    // maxFileSize:30 * 1024 * 1024,  //1g  //设置大一点 不然图片过大会报错
                    // base64LimitSize:10000000 * 1024, //1g以下插入 base64
                    // // 自定义插入图片
                    // customInsert(response,insertFn){
                    // //res 即服务端返回的结果
                    //     console.log(response);
                    //     const { url, alt=''} = response.data
                    //     // 从res中找到url alt href , 然后插入图片
                    //     insertFn(url,alt,href)
                    //     console.log(url);

                    // server: '/upload/img',
                    // maxFileSize:30 * 1024 * 1024,
                    // meta:{
                    //     token:store.state.token
                    // },
                    // headers:{
                    //     "Content-Type":'multipart/form-data;'
                    // },
                    // async customUpload(){
                    //     const formData = new FormData();
                    //     formData.append("file",file);
                    //     console.log(formData,'我是获取的图片');
                        // axios.post('/upload/img', formData, {  
                        //     headers: {  
                        //     }  
                        // })  
                        // .then(response => {  
                        //     // 成功时处理响应 
                        //     if (response.code === 200) { // 注意这里使用 response.data 来访问实际的数据  
                        //         console.log(response);
                        //         Message({  
                        //             message: response.message, // 同样，使用 response.data 来访问 message  
                        //             type: 'success'  
                        //         });  
                        //     } else {  
                        //         Message({  
                        //             message: '上传操作失败', // 可能需要根据实际情况调整消息内容  
                        //             type: 'error'  
                        //         });  
                        //     }  
                        
                        
                        // .catch(error => {  
                        //     // 捕获任何错误  
                        //     console.error('上传文件时发生错误:', error);  
                        //     Message({  
                        //         message: '上传文件时发生错误',  
                        //         type: 'error'  
                        //     });  
                        // });  
                    }
                    // }

                }
            },
            mode:'default', //or 'simple'
            selectedImageIndex: null,   // 记录被点击图片的索引
        }
    },
    created(){
    },
    mounted() {},
    beforeDestroy() {
        // const editor = this.editor
        // if (editor == null) return
        // editor.destroy() // 组件销毁时，及时销毁编辑器
        const editor = this.editor;
    if (editor) {
        editor.destroy();
        // 移除点击监听
        const container = editor.getEditableContainer();
        if (container && this.imageClickHandler) {
            container.removeEventListener('click', this.imageClickHandler);
        }
    }
    },
    methods:{
        ...mapActions('article',['postAddDate','editDate','getInfoBypageAction']),
        onCreated(editor) {
    this.editor = Object.seal(editor);
    const container = editor.getEditableContainer();

    // 图片点击处理
    this.imageClickHandler = (e) => {
        const target = e.target;
        if (target.tagName === 'IMG') {
            const images = container.querySelectorAll('img');
            const index = Array.from(images).indexOf(target);
            if (index !== -1) {
                this.selectedImageIndex = index;
                console.log('选中图片索引:', index);
            }
        }
    };
    container.addEventListener('click', this.imageClickHandler);

    // 监听选区变化，当选区不在图片上时重置 selectedImageIndex
    editor.on('selectionChange', () => {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            // 获取选区所在的节点
            let node = range.commonAncestorContainer;
            // 如果是文本节点，获取父元素
            if (node.nodeType === Node.TEXT_NODE) {
                node = node.parentNode;
            }
            // 检查该节点或祖先是否为图片
            let isImage = false;
            let el = node;
            while (el) {
                if (el.nodeType === Node.ELEMENT_NODE && el.tagName === 'IMG') {
                    isImage = true;
                    break;
                }
                el = el.parentNode;
            }
            if (!isImage) {
                this.selectedImageIndex = null;
            }
        } else {
            this.selectedImageIndex = null;
        }
    });
},
setImageWidth(width) {
    const editor = this.editor;
    if (!editor) {
        this.$message.warning('编辑器未初始化');
        return;
    }

    // 检查是否有选中的图片
    if (this.selectedImageIndex === null || this.selectedImageIndex === undefined) {
        this.$message.warning('请先在编辑器中点击选中一张图片');
        return;
    }

    let html = editor.getHtml();
    if (!html) {
        this.$message.warning('编辑器内容为空');
        return;
    }

    // 解析 HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const images = doc.querySelectorAll('img');

    // 检查索引是否有效
    if (this.selectedImageIndex >= images.length) {
        this.$message.warning('选中的图片已不存在，请重新点击选择');
        this.selectedImageIndex = null;
        return;
    }

    // 只修改索引对应的那一张图片
    const img = images[this.selectedImageIndex];
    img.style.width = width;
    img.style.height = 'auto';

    // 将修改后的 HTML 重新设置回编辑器
    const newHtml = doc.body.innerHTML;
    editor.setHtml(newHtml);

    this.$message.success(`图片宽度已设置为 ${width}`);
},
//         setImageWidth(width) {
//   const editor = this.editor
//   if (!editor) {
//     this.$message.warning('编辑器未初始化')
//     return
//   }

//   // 1. 获取当前所有 HTML 内容
//   let html = editor.getHtml()
//   if (!html) {
//     this.$message.warning('编辑器内容为空')
//     return
//   }

//   // 2. 构建一个临时的 DOM 容器来解析和修改 HTML
//   const parser = new DOMParser()
//   const doc = parser.parseFromString(html, 'text/html')
//   const images = doc.querySelectorAll('img')

//   if (images.length === 0) {
//     this.$message.warning('未找到图片')
//     return
//   }

//   // 3. 取最后一张图片（通常用户点击的图片是最后插入的，但更准确的需根据选区定位）
//   //    简单起见，我们取最后一张图片，或遍历所有图片设置相同宽度？
//   //    建议只修改选中的图片：但无法从 HTML 中确定选区，所以我们可以设置所有图片。
//   //    或者通过编辑器 API 获取选区位置，但复杂。
//   //    这里我们修改所有图片宽度，以满足大多数使用场景（一次修改所有图片）。
//   images.forEach(img => {
//     img.style.width = width
//     img.style.height = 'auto'
//   })

//   // 4. 将修改后的 HTML 转回字符串
//   const newHtml = doc.body.innerHTML

//   // 5. 重新设置编辑器内容
//   editor.setHtml(newHtml)

//   this.$message.success(`所有图片宽度已设置为 ${width}`)
// },
        onChange(editor) {
            // console.log("onChange", editor.getHtml()); // onChange 时获取编辑器最新内容
            this.form.content = editor.getHtml()
             this.selectedImageIndex = null; // 内容变化重置
        },
        update(file, insertFn){
            this.selectedFile.multipartFile = file;  
            this.selectedFile.prefix = file.name;  
            const formData = new FormData();  
            formData.append('multipartFile', this.selectedFile.multipartFile);  
            formData.append('prefix', this.selectedFile.prefix);  
            axios.post('/upload/img',formData,{

            }).then(response =>{
                if (response.code === 200) {
                    insertFn(response.data)
                    
            //         const url = response.data;
            //         const editor = this.editor;
            //         if (editor) {
            //     // 方式一：insertData（推荐）
            //     try {
            //         editor.insertData(`<img src="${url}" style="width:80%;" />`);
            //     } catch (e) {
            //         // 如果 insertData 报错，降级为 dangerouslyInsertHtml
            //         console.warn('insertData 失败，使用 dangerouslyInsertHtml', e);
            //         editor.dangerouslyInsertHtml(`<img src="${url}" style="width:80%;" />`);
            //     }
            //     Message({ message: '上传成功', type: 'success' });
            // } else {
            //     Message({ message: '编辑器未初始化', type: 'error' });
            // }
                    Message({  
                        message: response.message, // 同样，使用 response.data 来访问 message  
                        type: 'success'  
                    });
                }
            })
        },
        // 选择封面图片
        handleFileChange(event) {  
            var e = window.event || event;  
            // 确保有文件被选中  
            if (!e.target.files.length) {  
                Message({  
                    message: '请先选择文件',  
                    type: 'error'  
                });  
                return;  
            }  
        
            this.selectedFile = this.selectedFile || {}; // 确保 this.selectedFile 是对象  
            this.selectedFile.multipartFile = e.target.files[0];  
            this.selectedFile.prefix = e.target.files[0].name;  
        
            const formData = new FormData();  
            formData.append('multipartFile', this.selectedFile.multipartFile);  
            formData.append('prefix', this.selectedFile.prefix);  
        
            axios.post('/upload/img', formData, {  
                headers: {  
                    // 注意：当使用 FormData 时，通常不需要手动设置 'Content-Type'  
                    // 因为浏览器会自动设置正确的 'Content-Type'  
                    // 'Content-Type': 'multipart/form-data', // 这行可以注释掉或删除  
                }  
            })  
            .then(response => {  
                // 成功时处理响应 
                if (response.code === 200) { // 注意这里使用 response.data 来访问实际的数据  
                    this.form.coverImg = response.data 
                    this.src = response.data
                    Message({  
                        message: response.message, // 同样，使用 response.data 来访问 message  
                        type: 'success'  
                    });  
                } else {  
                    Message({  
                        message: '上传操作失败', // 可能需要根据实际情况调整消息内容  
                        type: 'error'  
                    });  
                }  
            })  
            .catch(error => {  
                // 捕获任何错误  
                console.error('上传文件时发生错误:', error);  
                Message({  
                    message: '上传文件时发生错误',  
                    type: 'error'  
                });  
            });  
        },
        // 重置表单
        resetForm(){
            this.form.id = null
            this.form.mainTitle = null
            this.form.subTitle = null
            this.form.introduction = null
            this.form.coverImg = null
            this.form.type = null
            this.form.publicationDate = null
            this.form.content = null
            this.selectedFile.multipartFile = null
            this.selectedFile.prefix = null
            this.src = null
            this.editor = null
            this.html = ''
             this.selectedImageIndex = null;  
        },
        // 点击空白和×取消dialog
        handleClose(){
            this.boxShow.isShow = false
            this.boxShow.flag = 0
            this.resetForm()
        },
        // 点击取消按钮
        cancel(){
            // 隐藏dialog
            this.boxShow.isShow = false
            this.boxShow.flag = 0
            this.resetForm()
        },
        // 点击确定按钮
        submit(form){
            // 隐藏dialog
            this.$refs.form.validate(valid =>{
                if (valid) {
                    if (form.id) {
                        this.editDate(this.form)
                    }else{
                        this.postAddDate(this.form)
                    }
                    this.getInfoBypageAction(this.formInline)
                }else{
                    this.$message.warning('表单信息填写有误,请检查')
                }
                this.resetForm()
            })
            this.boxShow.isShow = false
            this.boxShow.flag = 0
        },
        // onCreated(editor) {
        //     this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        // },
    }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
.el-select{
    width: 100%;
    }
    .el-radio.is-bordered+.el-radio.is-bordered{
    margin-left: 0px !important;
    margin-bottom: 5px;
    }
    .el-form-item{
    margin-bottom: 17px !important;
    }
    .el-autocomplete{
        width: 100%;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width: 100%;
    }
    ::v-deep [data-v-0e2a3a44] .el-input__inner {
        height: 1.875rem !important;
        line-height: 1.875rem !important;
        padding: 0.375rem 1.575rem !important;
    }
    .coverImg{
        /* width: 20%; */
        height: 40px;
    }

    .image-size-toolbar {
  padding: 8px 0;
  background: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-bottom: none;
  padding-left: 12px;
}
.image-size-toolbar .el-button {
  margin-right: 6px;
}
</style>